export { MarkerLayer } from "./MarkerLayer";
import { MeasurementLayer } from "./MeasurementLayer";
import { SimpleClientLayer } from "./SimpleClientLayer";
export { SketchLayer } from "./SketchLayer";
export const GroupLayer = new SimpleClientLayer({
    name: "GroupSelect",
    fill_color: 'rgba(255,255,255,0.5)',
    stroke_color: '#ffcc33',
    stroke_width: 2
});
export const MeasureLayer = new MeasurementLayer({
    name: "Measurement",
    fill_color: 'rgba(255,255,255,0.5)',
    stroke_color: '#ffcc33',
    stroke_width: 2
});
export const ZoomboxLayer = new SimpleClientLayer({
    name: "Measurement",
    fill_color: 'rgba(255,255,255,0.5)',
    stroke_color: '#ffcc33',
    stroke_width: 2
});
